import React, { useEffect } from "react";
import {
  CreditCardOutlined,
  HistoryOutlined,
  LineChartOutlined,
  LogoutOutlined,
  PaperClipOutlined,
  PayCircleOutlined,
  UserSwitchOutlined,
  ZoomInOutlined,
} from "@ant-design/icons";
import { Divider, Layout, Menu, theme } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import Profile from "../components/other/profile";
import MerchantHelper from "../components/other/merchantHelper";
import { bg_text } from "constant/css";
import { useMerchant } from "context/merchantContext";

const { Header, Content, Footer, Sider } = Layout;

const siderStyle = {
  overflow: "auto",
  height: "100vh",
  position: "sticky",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
};

const MerchantLayout = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { permissions } = useMerchant();
  const [protectedItems, setProtectedItems] = React.useState([]);
  const [selected, setSelected] = React.useState(null);
  const selectedKeys = selected ? [selected.key] : [];
  const navigate = useNavigate();
  const items = [
    {
      iconf: (props) => <LineChartOutlined {...props} />,
      icon: <LineChartOutlined />,
      key: "merchantDashboard",
      label: "Хянах самбар",
      permissions: null,
    },
    {
      iconf: (props) => <CreditCardOutlined {...props} />,
      icon: <CreditCardOutlined />,
      key: "merchantInvoiceList", //"merchantPayment",
      label: "Гүйлгээ",
      permissions: null,
      // children: [
      //   {
      //     iconf: (props) => <HistoryOutlined {...props} />,
      //     key: "merchantInvoiceList",
      //     label: "Нэхэмжлэл",
      //   },
      //   {
      //     iconf: (props) => <HistoryOutlined {...props} />,
      //     key: "vatLog",
      //     label: "НӨАТ",
      //   },
      // ],
    },
    {
      iconf: (props) => <UserSwitchOutlined {...props} />,
      icon: <UserSwitchOutlined />,
      key: "merchantVat",
      label: "Дэд мерчант",
      permissions: [4],
    },
    {
      iconf: (props) => <HistoryOutlined {...props} />,
      icon: <HistoryOutlined />,
      key: "vatLog",
      label: "НӨАТ Түүх (паркли)",
      permissions: [4],
    },
    {
      iconf: (props) => <CreditCardOutlined {...props} />,
      icon: (
        <img
          src="/smartbilling.png"
          className="rounded-xl"
          width={30}
          style={{ marginLeft: -10 }}
          height={30}
        />
      ),
      key: "xpayPayment",
      label: "Хэтэвч",
      permissions: [1],

      // children: [
      //   {
      //     iconf: (props) => <CreditCardOutlined {...props} />,
      //     key: "xpayPayment",
      //     label: "Төлбөр",
      //   },
      //   {
      //     iconf: (props) => <PaperClipOutlined {...props} />,
      //     key: "xpayDoc",
      //     label: "Гарын авлага",
      //   },
      // ],
    },
    {
      iconf: (props) => <UserSwitchOutlined {...props} />,
      icon: <UserSwitchOutlined />,
      key: "merchantIncome",
      label: "Орлого",
      permissions: [2, 3],
    },
    {
      iconf: (props) => <UserSwitchOutlined {...props} />,
      icon: <UserSwitchOutlined />,
      key: "subMerchantIncome",
      label: "Дэд мерчант орлого",
      permissions: [2, 3],
    },
    {
      iconf: (props) => <UserSwitchOutlined {...props} />,
      icon: <ZoomInOutlined />,
      key: "xpayDoc",
      label: "Таньд зориулав",
      permissions: null,
    },
    {
      iconf: (props) => <HistoryOutlined {...props} />,
      icon: <HistoryOutlined />,
      key: "merchantActionLog",
      label: "Үйлдлийн түүх",
      permissions: null,
    },
  ];
  useEffect(() => {
    const currentPath = window.location.pathname.split("/").pop();
    const findItemByKey = (key, items) => {
      for (const item of items) {
        if (item.key === key) return item;
        if (item.children) {
          const found = findItemByKey(key, item.children);
          if (found) return found;
        }
      }
      return null;
    };
    const currentItem = findItemByKey(currentPath, items);
    if (currentItem) {
      setSelected(currentItem);
    }
  }, []);
  useEffect(() => {
    console.log("Permissions changed:", permissions);
    const filteredItems = items.filter((item) => {
      if (!item.permissions) return true; // No permissions means always visible
      return item.permissions.some((perm) => permissions.includes(perm));
    });
    if (filteredItems.length > 0) setSelected(filteredItems[0]);
    setProtectedItems(filteredItems);
  }, [permissions]);
  const setAndNavigate = (e) => {
    const findItem = (key, items) => {
      for (const item of items) {
        if (item.key === key) return item;
        if (item.children) {
          const found = findItem(key, item.children);
          if (found) return found;
        }
      }
      return null;
    };
    const item = findItem(e.key, items);
    setSelected(item);
    navigate(e.key);
  };

  return (
    <Layout style={{ height: "100vh" }} hasSider>
      <Sider
        style={{ ...siderStyle, background: colorBgContainer }}
        className="sider"
      >
        <div className="logoContainer">
          <span className={`${bg_text} text-xl font-black`}>Смарт Биллинг</span>
          <span className={`${bg_text} text-sm`}>
            Rapid, Reliable, Rewarding
          </span>
        </div>
        <Menu
          theme="light"
          mode="inline"
          selectedKeys={selectedKeys}
          onClick={setAndNavigate}
          items={protectedItems}
          style={{ borderInlineEnd: "none" }}
        />
        <Profile />
      </Sider>

      <Layout style={{ display: "flex", flexDirection: "column" }}>
        <Header
          style={{
            background: colorBgContainer,
            padding: "0 24px",
            display: "flex",
            alignItems: "center",
            height: 64,
            justifyContent: "space-between",
            borderBottom: "1px solid #f0f0f0",
            position: "sticky",
            top: 0,
            zIndex: 1000,
          }}
        >
          {selected && (
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {selected.iconf({ style: { fontSize: 25, color: "#66baa8" } })}
              <h2 className={`${bg_text} font-bold text-lg`}>
                {selected.label}
              </h2>
            </div>
          )}
        </Header>
        <div
          className="absolute bottom-10 right-10 z-999"
          style={{ zIndex: 999 }}
        >
          <MerchantHelper />
        </div>
        {/* ✅ Make only Content scrollable */}
        <Content
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "5px 12px",
            background: colorBgContainer,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MerchantLayout;
